<template>
	<layer class="layer_posi" name="edit">
		<div class="wrap_layer_g layer_edit">
			<strong class="layer_tit">말머리/제목 편집</strong>
			<p class="info_addition">말머리와 제목 스타일을 편집할 수 있습니다.</p>
			<div class="edit_kind">
				<div class="division_edit">
					<div class="opt_selected_g opt_preface" :class="headContClass">
						<strong class="screen_out">검색 옵션 선택상자</strong>
						<div class="opt_tit">
							<a href="javascript:" class="tf_opt" @click.stop="toggleHeadContLayer">
								<span class="txt_selected">{{ selectedHeadCont || '말머리 없음' }}<span class="screen_out">선택됨</span></span>
								<span class="ico_bbs ico_arrow">옵션 더 보기</span>
							</a>
						</div>
						<div class="box_opt_menu" v-show="headContLayerOpen">
							<div class="inner_menu">
								<div class="menu_item">
									<a href="javascript:" class="link_menu" @click.stop="selectHeadCont('')">{{ '말머리 없음' }}</a>
								</div>
								<div class="menu_item" v-for="headCont in headConts">
									<a href="javascript:" class="link_menu" @click.stop="selectHeadCont(headCont)">{{ headCont }}</a>
								</div>
							</div>
							<div class="menu_add">
								<input id="head-cont-add-input" type="text" class="inp_add" placeholder="말머리 추가" @click.stop :value="newHeadCont" @input="onHeadContInput">
								<button id="head-cont-add-btn" type="button" class="btn_g_ico btn_plus" @click.stop="_addHeadCont">
									<span class="ico_bbs ico_plus">머리말 추가하기</span>
								</button>
							</div>
						</div>
					</div>
				</div>
				
				<div class="division_edit">
					<div class="text_edit_bold">
						<button id="title-bold-btn" type="button" class="btn_g_ico btn_edit_font" :class="{ico_on: bold}" @click.stop="toggleBold">
							<span class="ico_bbs ico_text_bold">{{ bold ? '텍스트 얇게하기' : '텍스트 굵게하기' }}</span>
						</button>
					</div>
					<div class="text_edit_color" :class="colorLayerClass">
						<button id="title-color-btn" type="button" class="btn_g_ico btn_edit_font" :class="{ico_on: colorLayerOpen}" @click.stop="toggleColorLayer">
							<span class="ico_bbs ico_text_color">텍스트 색상바꾸기</span>
							<span class="color_selected" :style="{backgroundColor: selectedColor}"></span>
						</button>
						<div class="layer_color">
							<span class="ico_bbs ico_editor_arrow"></span>
							<div class="list_color">
								<div class="color_item">
									<button type="button" class="color_circle btn_g_ico" @click.stop="selectColor('')">
										<span class="ico_bbs ico_none">기본색상</span>
									</button>
								</div>
								<div class="color_item" :class="{on_check: selectedColor === color}" v-for="color in colors">
									<button type="button" class="color_circle btn_g_ico" :class="colorItemClass(color)" :style="colorItemStyle(color)" @click.stop="selectColor(color)">
										<span class="screen_out">컬러코드 {{ color }}</span>
										<span class="ico_bbs ico_selected">선택됨</span>
									</button>
								</div>
							</div>
							<div class="box_info">
								<div class="color_info" @click.stop>
									<span class="color_circle" :style="colorCircleStyle" ref="colorCircle"></span>
									<span class="txt_color"><span class="txt_item">#</span>
										<input id="title-color-input" maxlength="6" pattern="[0-9a-fA-F]{3,6}" class="txt_inp" type="text" placeholder="000000" v-model="inputColor">
									</span>
								</div>
								<button id="title-color-input-btn" type="button" class="btn_input" @click.stop="selectInputColor">입력</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="layer_btn area_btn_g">
				<div class="area_r">
					<button id="title-cancel-btn" type="button" class="btn_g type3">취소</button>
					<button id="title-confirm-btn" type="button" class="btn_g type4" @click="editTitle">확인</button>
				</div>
			</div>
		</div>
	</layer>
</template>

<script>
import Layer from './Layer.vue';
import {getBytes} from '@src/utils.mjs';
import {
	MAX_HEAD_CONT_COUNT,
	MAX_HEAD_CONT_BYTE,
	ADD_HEAD_CONT_RESPONSE_MESSAGE,
	ADD_HEAD_CONT_RESPONSE_TYPE,
	TITLE_COLORS,
	DEFAULT_COLOR,
	MIN_COLOR_LENGTH
} from '../../constants.mjs';

export default {
	components: {Layer},
	props: {
		grpid: {
			type: String
		},
		fldid: {
			type: String
		},
		_headConts: {
			type: Array,
			default: () => ([])
		},
		callback: {
			type: Function,
			default: () => null
		}
	},
	data() {
		return {
			headContLayerOpen: false,
			selectedHeadCont: '',
			newHeadCont: '',
			newHeadConts: [],
			headContChanged: false,
			
			bold: false,

			colorLayerOpen: false,
			selectedColor: '',
			colors: TITLE_COLORS,
			inputColor: '',
			fontChanged: false
		};
	},
	computed: {
		headConts() {
			return [...this._headConts, ...this.newHeadConts]
		},
		headContClass() {
			return {
				open_layer: this.headContLayerOpen
			};
		},
		
		colorLayerClass() {
			return {
				open_layer: this.colorLayerOpen
			};	
		},
		colorItemClass() {
			return (color) => ({
				color_white: color === '#ffffff'
			});
		},
		colorItemStyle() {
			return (color) => ({
				backgroundColor: color
			});
		},
		colorCircleStyle() {
			return {
				backgroundColor: this.inputColor ? `#${this.inputColor.toLowerCase()}` : (this.selectedColor || DEFAULT_COLOR)
			};
		}
	},
	methods: {
		toggleHeadContLayer() {
			this.headContLayerOpen = !this.headContLayerOpen;
		},
		selectHeadCont(headCont) {
			this.selectedHeadCont = headCont;
			this.headContChanged = true;
			this.headContLayerOpen = false;
		},
		onHeadContInput({currentTarget}) {
			this.newHeadCont = currentTarget.value;
		},
		handleHeadContResponse(responseType) {
			switch (responseType) {
				case ADD_HEAD_CONT_RESPONSE_TYPE.SUCCESS:
					this.newHeadConts.push(this.newHeadCont);
					break;
				case ADD_HEAD_CONT_RESPONSE_TYPE.EXIST:
					alert(ADD_HEAD_CONT_RESPONSE_MESSAGE[responseType]);
					break;
				case ADD_HEAD_CONT_RESPONSE_TYPE.FAIL:
					alert(ADD_HEAD_CONT_RESPONSE_MESSAGE[responseType]);
			}
			
			this.newHeadCont = '';
		},
		_addHeadCont() {
			if (this.headConts.length > MAX_HEAD_CONT_COUNT) {
				alert('더 이상 말머리를 추가할 수 없습니다.');
				return;
			}

			if (!this.newHeadCont) {
				alert('말머리를 입력해 주세요.');
				return;
			}

			if (getBytes(this.newHeadCont) > MAX_HEAD_CONT_BYTE) {
				alert('7자 이내로 입력해 주시기 바랍니다.');
				return;
			}

			BoardManagement.addHeadContent(this.grpid, this.fldid, this.newHeadCont, {
				callback: this.handleHeadContResponse
			});
		},

		toggleBold() {
			this.bold = !this.bold;
			this.fontChanged = true;
		},
		
		toggleColorLayer() {
			this.colorLayerOpen = !this.colorLayerOpen;
		},
		selectColor(color) {
			this.selectedColor = color;
			this.inputColor = color.slice(1).toUpperCase();
			this.fontChanged = true;
			this.colorLayerOpen = false;
		},
		selectInputColor() {
			const color = this.inputColor.length > MIN_COLOR_LENGTH ? `#${this.inputColor.toLowerCase()}` : DEFAULT_COLOR;
			this.selectColor(color);
			this.colorLayerOpen = false;
		},
		
		editTitle() {
			this.callback(this.selectedHeadCont, this.bold, this.selectedColor, this.headContChanged, this.fontChanged);
		}
	}
}
</script>
